import type { LeadProfileDownloadStatus } from "@/src/components/lead-profile-download-dialog/LeadProfileDownloadProvider"

import Stack from "@mui/material/Stack"
import Dialog from "@mui/material/Dialog"
import Typography from "@mui/material/Typography"
import DialogContent from "@mui/material/DialogContent"
import CircularProgress from "@mui/material/CircularProgress"

interface Props {
    open: boolean
    downloadStatus: LeadProfileDownloadStatus
}

const getProfileDownloadContent = (downloadStatus: LeadProfileDownloadStatus) => {
    if (downloadStatus === "downloadingProfile") {
        return {
            title: "Downloading profile...",
            description: "Your download should start automatically. Please keep this page open.",
        }
    }

    return {
        title: "Generating profile...",
        description: "We're preparing the candidate profile PDF. It will download automatically once ready.",
    }
}

const LeadProfileDownloadDialog = ({ open, downloadStatus }: Props) => {
    const profileDownloadContent = getProfileDownloadContent(downloadStatus)

    return (
        <Dialog
            fullWidth
            maxWidth={false}
            open={open}
            disableEscapeKeyDown
            PaperProps={{ sx: { maxWidth: 420, p: "40px" } }}
        >
            <DialogContent>
                <Stack alignItems="center" spacing={2}>
                    <CircularProgress size={40} />

                    <Typography textAlign="center" variant="h6">
                        {profileDownloadContent.title}
                    </Typography>

                    <Typography textAlign="center" variant="body2" color="#5E6C84">
                        {profileDownloadContent.description}
                    </Typography>
                </Stack>
            </DialogContent>
        </Dialog>
    )
}

export default LeadProfileDownloadDialog
